import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100vw',
    },
    content: {
        backgroundColor: theme.palette.backgroundColor,
        flexGrow: 1,        
        overflowY: 'auto',
        overflowX: 'hidden',
        [theme.breakpoints.up("md")]: {
            maxHeight: '94vh',
        },
    },
    notHamburguer: {
        backgroundColor: theme.palette.backgroundColor,
        flexGrow: 1,        
        overflowY: 'auto',
        overflowX: 'hidden',
        [theme.breakpoints.up("md")]: {
            marginLeft:  theme.sizes.drawer.desktopWidth,
            maxHeight: '94vh',
        },
    },
}));

export default useStyles;